import React from 'react';
import '../../css/LeaveQuota.css';
import { useTranslation } from 'react-i18next';

const PermissionTypes = ({ data, language }) => {
    const { t } = useTranslation();

    return (
        <div className="w-100">
            {data && data.length > 0 ? (
                <>
                    <div>{t('Please select the type of permission.')}</div>
                    <ol>
                        {data.map((permission, index) => (
                            <li key={index}>{permission.Atext}</li>
                        ))}
                    </ol>
                </>
            ) : (
                <p>{t("Sorry, you don't have permission types available")}</p>
            )}
        </div>
    );
};

export default PermissionTypes;
